/** Map app routes to i18n keys under `nav.*` */
export const ROUTE_I18N_KEYS = {
  "/": "nav.dashboard",
  "/pos": "nav.pointOfSale",
  "/pos/held-bills": "nav.heldBills",
  "/masters/categories": "nav.categories",
  "/masters/products": "nav.products",
  "/masters/promotions": "nav.promotions",
  "/masters/customers": "nav.customers",
  "/masters/suppliers": "nav.suppliers",
  "/inventory": "nav.inventoryHub",
  "/inventory/stock": "nav.stockSummary",
  "/inventory/batches": "nav.batches",
  "/inventory/purchase-orders": "nav.purchaseOrders",
  "/inventory/grn": "nav.grn",
  "/inventory/transfers": "nav.transfers",
  "/inventory/adjustments": "nav.adjustments",
  "/inventory/wastage": "nav.wastage",
  "/inventory/returns": "nav.supplierReturns",
  "/inventory/alerts": "nav.inventoryAlerts",
  "/accounts/schedules": "nav.schedules",
  "/accounts/accounts": "nav.accountsChart",
  "/accounts/receipt": "nav.receiptVoucher",
  "/accounts/payment": "nav.paymentVoucher",
  "/accounts/journal": "nav.journalVoucher",
  "/accounts/contra": "nav.contraVoucher",
  "/accounts/debit-note": "nav.debitNote",
  "/accounts/credit-note": "nav.creditNote",
  "/accounts/ledger": "nav.ledgerReport",
  "/accounts/trial-balance": "nav.trialBalance",
  "/accounts/profit-loss": "nav.profitLoss",
  "/accounts/balance-sheet": "nav.balanceSheet",
  "/accounts/cash-book": "nav.cashBook",
  "/accounts/bank-book": "nav.bankBook",
  "/accounts/day-book": "nav.dayBook",
  "/reports": "nav.reportCenter",
  "/admin/users": "nav.users",
  "/admin/roles": "nav.roles",
  "/admin/audit-log": "nav.auditLog",
  "/admin/counters": "nav.counters",
  "/admin/printers": "nav.printers",
  "/admin/company": "nav.companySetup",
  "/admin/store": "nav.storeSetup",
  "/admin/tax": "nav.taxSettings",
  "/admin/general": "nav.generalSettings",
  "/admin/online-store": "nav.onlineStore",
  "/online/orders": "nav.onlineOrders",
  "/online/history": "nav.onlineHistory",
  "/reports/online-orders": "nav.onlineOrders",
};

/** Map report routes to i18n keys under `reports.*` */
export const REPORT_I18N_KEYS = {
  "/reports/daily-sales": "reports.dailySales",
  "/reports/counter-sales": "reports.counterSales",
  "/reports/item-sales": "reports.itemSales",
  "/reports/tax": "reports.tax",
  "/reports/category-sales": "reports.catSales",
  "/reports/top-items": "reports.topItems",
  "/reports/customer-sales": "reports.customer",
  "/reports/customer-ledger": "reports.customerLedger",
  "/reports/customer-age-wise": "reports.customerAgeWise",
  "/reports/supplier-summary": "reports.supplier",
  "/reports/supplier-ledger": "reports.supplierLedger",
  "/reports/supplier-age-wise": "reports.supplierAgeWise",
  "/reports/order-summary": "reports.orderSummary",
  "/reports/cash-collection": "reports.cashCollection",
  "/reports/z-report": "reports.zReport",
  "/reports/x-report": "reports.xReport",
  "/reports/sales-day-book": "reports.salesDayBook",
  "/reports/ledger": "reports.ledger",
  "/reports/trial-balance": "reports.trialBalance",
  "/reports/profit-loss": "reports.profitLoss",
  "/reports/balance-sheet": "reports.balanceSheet",
  "/reports/cash-book": "reports.cashBook",
  "/reports/bank-book": "reports.bankBook",
  "/reports/day-book": "reports.dayBook",
  "/reports/financial-statements": "reports.financialStatements",
  "/reports/condensed-stock": "reports.inventory",
};
